import { TYPES as ApiGatewayTypes } from '@desygner/ui-core-api-gateway';
import { TYPES as MonitoringTypes } from '@desygner/ui-core-monitoring';

import { TYPES as VIEWER_TYPES } from './core/viewer/viewer.types';
import { TYPES as STORE_TYPES } from './store';

export const TYPES = {
  Theme: Symbol('Theme'),

  Viewer: VIEWER_TYPES,
  MonitoringService: MonitoringTypes.MonitoringService,
  ApiGateway: ApiGatewayTypes.ApiGateway,
  Store: STORE_TYPES,
};
